// DCTL-2654: the WPD page can outlive its session. A logout or store reset
// that fails to navigate away leaves the page rendering while every save path
// bails on the missing session or paper. Once the page holds a loaded
// document, either loss means nothing further can be saved, and the page has
// to say so instead of dropping edits quietly.
export function shouldBlockSaving({
	loadComplete,
	isMounted,
	isAuthenticated,
	paperEmpty,
}) {
	if (!loadComplete || !isMounted) {
		return false;
	}
	return !isAuthenticated || Boolean(paperEmpty);
}

// "HH:MM" for the blocking dialog; null when nothing was ever saved or loaded.
export function formatSaveTime(date) {
	if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
		return null;
	}
	return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}
